export const programmesByCategory = {
  undergraduate: [
    "BBA (Honours)",
    "BCA (Honours)",
    "B.A (Honours) – Political Science",
    "B.A (Honours) – History",
    "B.A (Honours) – Economics",
    "B.A (Honours) – Special English",
    "B.Com (Honours) – General",
    "B.Com (Honours) – Computer Applications",
    "B.Sc (Honours) – Mathematics",
    "B.Sc (Honours) – Physics",
    "B.Sc (Honours) – Chemistry",
    "B.Sc (Honours) – Botany",
    "B.Sc (Honours) – Zoology",
    "B.Sc (Honours) – Statistics",
    "B.Sc (Honours) – Computer Science",
    "B.Sc (Honours) – Home Science",
    "B.Sc (Honours) – Microbiology"
  ],

  postgraduate: [
    "M.A English",
    "M.Com",
    "M.Com (Professional)",
    "M.Sc Computer Science",
    "M.Sc Organic Chemistry",
    "M.B.A",
    "M.B.A (Finance)",
    "M.C.A",
    "I.M.B.A (Integrated MBA)"
  ],

  professional: [
    "LL.B – 3 Years",
    "LL.B – 5 Years"
  ],

  research: [
    "Ph.D. (as per UGC & Rayalaseema University regulations)"
  ]
};
